import React from 'react';

import './widget-product-slider-desktop-basic.scss';

const WidgetProductSliderDesktopBasic: React.FC<any> = props => (
    <div className="react-multi-carousel-list w-product-slider-d__list">
        <ul className="react-multi-carousel-track">
            {
                React.Children.map(props.children, child => (
                    <li className={`react-multi-carousel-item ${props.itemClass}`}>
                        {child}
                    </li>
                ))
            }
        </ul>
    </div>
);

export default WidgetProductSliderDesktopBasic;
